import postCreateTranscript from "@/services/postCreateTranscript";
import { reportError } from "@/utils/reportError";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

export interface CreateTranscriptData {
  recordingId: string;
}

const usePostCreateTranscript = () => {
  const { mutate, mutateAsync, isPending, isError, error, isSuccess, status } = useMutation<boolean, AxiosError, CreateTranscriptData>({
    mutationFn: async (data: CreateTranscriptData) => {
      const result = await postCreateTranscript(data);
      if (result instanceof AxiosError) {
        throw result;
      }

      return result;
    },
    mutationKey: ["postCreateTranscript"],
    onError: (error: AxiosError) => {
      reportError(error, {
        eventName: "POST-CREATE-TRANSCRIPT",
        properties: {
          reason: `Error with create transcript - ${error?.message}`,
        },
      });
    },
  });

  return { mutate, mutateAsync, isPending, isError, error, isSuccess, status };
};

export default usePostCreateTranscript;
